<script lang="ts">
  import Button from './Button.svelte';

  interface Props {
    page: number;
    total: number;
    perPage: number;
    /** O que se conta, no plural: "contatos", "envios". */
    noun: string;
    /** Nome da navegação para o leitor de tela: duas na mesma tela não podem se chamar igual. */
    label: string;
    onGo: (page: number) => void;
  }

  let { page, total, perPage, noun, label, onGo }: Props = $props();

  const pages = $derived(Math.max(1, Math.ceil(total / perPage)));
  const isFirst = $derived(page <= 1);
  const isLast = $derived(page >= pages);
</script>

<!-- aria-disabled, não disabled: o botão desligado no clique perdia o foco, e quem navega por teclado voltava ao topo. -->
<nav class="pager" aria-label={label}>
  <Button size="sm" aria-disabled={isFirst} onclick={() => !isFirst && onGo(page - 1)}>← Anterior</Button>
  <span class="where">Página {page} de {pages} · {total} {noun}</span>
  <Button size="sm" aria-disabled={isLast} onclick={() => !isLast && onGo(page + 1)}>Próxima →</Button>
</nav>

<style>
  .pager {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--space-4);
    padding-top: var(--space-3);
  }
  .where {
    color: var(--text-tertiary);
    font-size: 12px;
  }
</style>
